import { put, takeEvery } from 'redux-saga/effects'
import cookie from 'react-cookie'
import {
  CHANGE_AUTH_STATE,
  USER_AUTHENTICATED,
  INIT_AUTH_FLOW_PARAMS,
  AUTH_FLOW_PARAMS_INITIALIZED,
} from '../actions/index'

function* onUserAuthenticated(action) {
  yield put({
    type: USER_AUTHENTICATED,
    payload: {
      authData: action.payload,
    },
  })
}

function* onInitAuthFlowParams(action) {
  const { payload } = action

  if (payload.redirect_uri) {
    cookie.save('redirectUri', decodeURI(payload.redirect_uri), { maxAge: 600 })
  }

  yield put({
    type: AUTH_FLOW_PARAMS_INITIALIZED,
    payload: {
      redirectUri: cookie.load('redirectUri') || null,
    },
  })
}

export function* changeAuthState() {
  yield takeEvery(CHANGE_AUTH_STATE, onUserAuthenticated)
}

export function* initAuthFlowParams() {
  yield takeEvery(INIT_AUTH_FLOW_PARAMS, onInitAuthFlowParams)
}



// WEBPACK FOOTER //
// ./src/sagas/auth.js